import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonCardTableComponent } from '@okcargo-apps/layout-ionic';
import { MessagesUiService, MessageUiIonicComponent } from '@okcargo-apps/messages-ui';
import { IFreightBasicForShipper } from '@okcargo-apps/shared-domain';
import { Observable } from 'rxjs';
import { FreightShipperCardComponent } from '../freight-shipper-card/freight-shipper-card.component';
import { FreightShipperService } from '../freight-shipper.service';

@Component({
  selector: 'lib-freight-shipper-pending-list',
  templateUrl: './freight-shipper-pending-list.component.html',
  styleUrls: ['./freight-shipper-pending-list.component.scss'],
  imports: [
    CommonModule,
    SkeletonCardTableComponent,
    MessageUiIonicComponent,
    TranslateModule,
    FreightShipperCardComponent,
  ],
})
export class FreightShipperPendingListComponent {
  private readonly freightShipService = inject(FreightShipperService);

  public freights$: Observable<IFreightBasicForShipper[]>;

  private readonly messagesUiService = inject(MessagesUiService);

  public messages = computed(() => this.messagesUiService.getMessagesForObjectId('freight-ship-pending'));

  constructor() {
    this.freights$ = this.freightShipService.freightsShipPending$;
  }

  get loading(): boolean {
    return this.freightShipService.freightsShipNotFinishedLoading();
  }
}
